import { getFiltersOptions } from '@/ducks/filtersOptions';
import { MNVV_ELIGIBLE_META_TYPES } from '@/ducks/mnvv/constants';
import { selectIsMnvv } from '@/ducks/mnvv/selectors';

import { FILTER_KEY, type FiltersConfigValue, type FiltersTypes } from '../types';

const cabinType: FiltersConfigValue<FiltersTypes[FILTER_KEY.cabinType]> = {
  getValue: ({ state, value }) => {
    const { cabinTypes } = getFiltersOptions(state);
    const cabinType = value && cabinTypes.find((t) => t.code === value)?.code;
    return cabinType || null;
  },
  isValueValidForURL({ state, value }) {
    if (!value) return true;

    const isMNVV = selectIsMnvv(state);
    if (!isMNVV) return true;
    return MNVV_ELIGIBLE_META_TYPES.isSupersetOf(new Set(Array.isArray(value) ? value : [value]));
  },
};

export default cabinType;
